import React, { useState, useEffect } from 'react';
import {
  AutocompleteInput,
  FormDataConsumer,
  SelectInput,
  useTranslate,
} from 'react-admin';
import { disableAutofillOptions } from '../helper';

const ReferenceChild = (props) => {
  const [initialChoices, setInitialChoices] = useState(null);
  const {
    optionText,
    source,
    choices,
    setFilter,
    className,
    translateChoice,
    helperText,
    allowEmpty,
    onChange,
    emptyText,
    validate,
    resource,
    label,
  } = props;
  // useEffect will help to prevent the swap of autocomplete to selecinput during query search result less than 20
  useEffect(() => {
    if (initialChoices < choices.length) {
      setInitialChoices((prevState) =>
        prevState < choices.length ? choices.length : prevState,
      );
    }
  }, [choices, initialChoices]);
  const translate = useTranslate();
  return (
    <FormDataConsumer source={source}>
      {({ formData, ...rest }) => {
        const inputProps = { ...rest };
        if (resource && !label) {
          inputProps.label = translate(
            `resources.${resource}.fields.${source}`,
          );
        }
        if (initialChoices && initialChoices <= 20) {
          return (
            <SelectInput
              {...inputProps}
              validate={validate}
              choices={choices}
              optionText={optionText}
              source={source}
              className={className}
              translateChoice={translateChoice}
              helperText={helperText}
              allowEmpty={allowEmpty}
              onChange={onChange}
              label={label}
            />
          );
        }
        return (
          <AutocompleteInput
            {...inputProps}
            validate={validate}
            choices={choices}
            optionText={optionText}
            source={source}
            setFilter={setFilter}
            className={className}
            translateChoice={translateChoice}
            helperText={helperText}
            allowEmpty={allowEmpty}
            onChange={onChange}
            emptyText={emptyText}
            options={disableAutofillOptions}
            label={label}
          />
        );
      }}
    </FormDataConsumer>
  );
};

export default ReferenceChild;
